import $api from "../Api";
import Endpoints from "../Endpoints";
import normalizeBaseResult from "../helpers/baseResult";

/**
 * Uyumsoft tenant onboarding'ini başlatır.
 * Başarılı yanıttaki data.apiKey yalnızca bu cevapta dönen secret'tır;
 * request katmanında kalıcı olarak saklanmaz.
 *
 * @param {{
 *   name: string,
 *   slug: string,
 *   taxNumber: string,
 *   legalName: string,
 *   address: string,
 *   defaultScenario: "Automated"|"EInvoice"|"EArchive",
 *   defaultSeries: string,
 *   uyumUsername: string,
 *   uyumPassword: string
 * }} form
 */
export const Register = async (form) => {
  const response = await $api.post(Endpoints.EInvoiceCompany.Register(), form);
  return normalizeBaseResult(response);
};

/** @param {{ uyumUsername: string, uyumPassword: string }} form */
export const UpdateUyumCredentials = async (form) => {
  const response = await $api.put(
    Endpoints.EInvoiceCompany.UpdateUyumCredentials(),
    form
  );
  return normalizeBaseResult(response);
};

export const RotateApiKey = async () => {
  const response = await $api.post(Endpoints.EInvoiceCompany.RotateApiKey());
  return normalizeBaseResult(response);
};

export const Deactivate = async () => {
  const response = await $api.delete(Endpoints.EInvoiceCompany.Deactivate());
  return normalizeBaseResult(response);
};

export default {
  Register,
  UpdateUyumCredentials,
  RotateApiKey,
  Deactivate,
};
